import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=4655a4cd&scoped=true&"
import script from "./Sku.vue?vue&type=script&lang=js&"
export * from "./Sku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655a4cd",
  null
  
)

export default component.exports